import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import moment from 'moment';
import { MessageService } from 'primeng/api';
import { Base64 } from 'src/app/models/base64';
import { AppConfigService } from 'src/app/services/app-config.service';
import { NeighborPermission, NeighborPermissionGenSvc, NotificationsGenSvc, QuoteGenSvc, QuoteWorkOrder } from 'src/app/services_autogenerated/generated_services';

@Component({
    selector: 'app-anonymous-customer-quote-page',
    templateUrl: './anonymous-customer-quote-page.component.html',
    styleUrls: ['./anonymous-customer-quote-page.component.css'],
    standalone: false
})
export class AnonymousCustomerQuotePageComponent implements OnInit {
  
  quote: QuoteWorkOrder;
  contactPhoneNumber: string;
  isLoading: boolean;

  weeksOutDateCalculation = {
    start: undefined, end: undefined
  };

  neighborPermission: NeighborPermission;

  constructor(private route: ActivatedRoute,
    private quoteService: QuoteGenSvc,
    private neighborPermissionService: NeighborPermissionGenSvc,
    private emailService: NotificationsGenSvc,
    private messageService: MessageService,
    private configService: AppConfigService) { }

  ngOnInit() {
    this.contactPhoneNumber = this.configService.appConfig.contactPhoneNumber;
    this.isLoading = true;

    const id = +this.route.snapshot.paramMap.get('id');
    const npId = this.route.snapshot.queryParamMap.get('npId');
    
    if (id && npId) {
      this.quoteService.getAnon(id).subscribe(res => {
        // If someone gets here for a quote that doesn't need neighbor's permission, just show the blank page
        // saying the quote couldn't be found.
        if (res.neighborPermissionRequired) {
          this.quote = res;
          if (res.priorityTypeShortcut && res.priorityTypeShortcut.weeksOutStart !== undefined) {
            this.neighborPermission = this.quote.neighborPermissions.find(np => np.id == +npId && !np.deleted);
            this.weeksOutDateCalculation = {
              start: moment(new Date()).add(res.priorityTypeShortcut.weeksOutStart, 'w'),
              end: moment(new Date()).add(res.priorityTypeShortcut.weeksOutEnd, 'w')
            };
          }
        }

        this.isLoading = false;
      }, error => this.isLoading = false);
    } else if (id) {
      this.quoteService.getAnon(id).subscribe(res => {
        // If someone gets here for a quote that doesn't need neighbor's permission, just show the blank page
        // saying the quote couldn't be found.
        if (res.neighborPermissionRequired) {
          this.quote = res;
          if (res.priorityTypeShortcut && res.priorityTypeShortcut.weeksOutStart !== undefined) {
            res.neighborPermissions = res.neighborPermissions.filter(np => !np.deleted);
            this.neighborPermission = this.quote.neighborPermissions[0];
            this.weeksOutDateCalculation = {
              start: moment(new Date()).add(res.priorityTypeShortcut.weeksOutStart, 'w'),
              end: moment(new Date()).add(res.priorityTypeShortcut.weeksOutEnd, 'w')
            };
          }
        }

        this.isLoading = false;
      }, error => this.isLoading = false);
    } else {
      this.isLoading = false;
    }
  }
  
  onNeighborInfoUpdate() {
    this.neighborPermission.firstName = this.neighborPermission.firstName.trim();
    this.neighborPermission.lastName = this.neighborPermission.lastName.trim();
    this.neighborPermission.email = this.neighborPermission.email.trim();
  }

  isEmptyOrSpaces(str): boolean{
    return str === null || str.match(/^ *$/) !== null;
  }
  
  save() {
    if (this.isEmptyOrSpaces(this.neighborPermission.firstName) || this.isEmptyOrSpaces(this.neighborPermission.firstName) || this.isEmptyOrSpaces(this.neighborPermission.lastName) || this.isEmptyOrSpaces(this.neighborPermission.neighborSignature)) {
      this.messageService.add({
        severity: 'info',
        summary: 'Information Required',
        detail: 'Please enter your first name, last name, email address, and sign below.'
      });
      return;
    }

    this.neighborPermissionService.update(this.neighborPermission).subscribe(res => {
      this.messageService.add({
        severity: 'success',
        summary: 'Save Successful',
        detail: 'Thank you! You should received a confirmation email for your records shortly.'
      });
      this.emailService.sendCustomerNeighborSignedEmail(this.quote, this.neighborPermission.id, Base64.encode(this.quote.customerId.toString()), Base64.encode(this.quote.id.toString())).subscribe();
    }, error => {
      this.messageService.add({
        severity: 'error',
        summary: 'Unable to Save',
        detail: `Please verify the information is correct, including having a valid email address. If the problem persists, 
                please contact ${this.contactPhoneNumber} for assistance.`
      });
    });
  }

  onUpdatedNeighborSignature(signature: string) {
    this.neighborPermission.neighborSignature = signature;
    this.neighborPermission.signedDate = new Date();
  }
}
